import { FlexContainer } from "@components/ui/flex_container";
import Image from "next/image";
import React from "react";

export default function ServiceHeader({ image, title }) {
    return (
        <FlexContainer
            className="service-header"
            alignItems="center"
            style={{ marginBottom: "20px" }}
        >
            <Image priority src={image} alt="" width={143} height={143} />
            <h2>{title}</h2>
        </FlexContainer>
    );
}
